import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { WalletCurrencyType } from 'api/Trading-Accounts/Types/WalletCurrencyType'
import { multiSelectFilterCell } from 'components/Filter/FilterCell'
import { useAppSelector } from 'store'

export const CurrenciesFilterCell = multiSelectFilterCell({
  items: Object.keys(WalletCurrencyType).map((x) => ({ id: x, value: x, label: x })),
  options: {
    operator: '==',
  },
})

export const CompaniesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const tickmillCompanies = useAppSelector((state) => state.identity.tickmillCompanies)

  return multiSelectFilterCell({
    items: tickmillCompanies.map((x) => ({ id: x.id, value: x.id, label: x.name })),
    options: {
      operator: '==',
    },
  })(props)
}

export const CountriesFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const countries = useAppSelector((state) => state.identity.countries)

  return multiSelectFilterCell({
    items: countries.map((x) => ({ id: x.id, value: x.id, label: x.name })),
    options: {
      operator: '==',
    },
  })(props)
}
